var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "dataList" },
    [
      _c(
        "div",
        { staticClass: "list-wrap" },
        [
          _vm.datalist.dataType == 1
            ? [
                Object.keys(_vm.datalist.chartdata).length
                  ? _c("ChartContent", {
                      staticStyle: { height: "300px" },
                      attrs: { data: { option: _vm.datalist.chartdata } },
                    })
                  : _vm._e(),
                _vm._l(_vm.datalist.tabledata.result, function (item, index) {
                  return _c("div", { key: index, staticClass: "list-item" }, [
                    _c("span", { staticClass: "index" }, [
                      _vm._v(_vm._s(index + 1) + "、"),
                    ]),
                    _c(
                      "span",
                      {
                        staticClass: "clickCompany",
                        on: {
                          click: function ($event) {
                            return _vm.clickCompany(item.id)
                          },
                        },
                      },
                      [_vm._v(_vm._s(item.name))]
                    ),
                  ])
                }),
              ]
            : [
                [2, 4].includes(_vm.datalist.dataType) &&
                Object.keys(_vm.datalist.chartdata).length
                  ? _c("ChartContent", {
                      staticStyle: { height: "300px" },
                      attrs: { data: { option: _vm.datalist.chartdata } },
                    })
                  : _vm._e(),
                [2, 3, 5].includes(_vm.datalist.dataType)
                  ? _c("main-table", {
                      staticClass: "mainTable",
                      attrs: {
                        data: _vm.datalist.tabledata,
                        "show-page": false,
                        "show-search": false,
                        "show-page-size": false,
                        tableCss: 1,
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "name",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-link",
                                  {
                                    attrs: {
                                      underline: false,
                                      type: "primary",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.clickCompany(scope.row.id)
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(scope.row.name))]
                                ),
                              ]
                            },
                          },
                          {
                            key: "supplierName",
                            fn: function (scope) {
                              return [
                                _c("span", { staticClass: "companyNameLink" }, [
                                  _c(
                                    "a",
                                    {
                                      directives: [
                                        {
                                          name: "track",
                                          rawName: "v-track",
                                          value: { triggerType: "click" },
                                          expression: "{triggerType: 'click'}",
                                        },
                                      ],
                                      staticClass: "aclss",
                                      attrs: {
                                        href: `${_vm.localhost}/company/detail/${scope.row.supplierId}/0?wlf=ai_gpt`,
                                        target: "_blank",
                                      },
                                    },
                                    [_vm._v(_vm._s(scope.row.supplierName))]
                                  ),
                                ]),
                              ]
                            },
                          },
                          {
                            key: "buyerName",
                            fn: function (scope) {
                              return [
                                _c("span", { staticClass: "companyNameLink" }, [
                                  _c(
                                    "a",
                                    {
                                      directives: [
                                        {
                                          name: "track",
                                          rawName: "v-track",
                                          value: { triggerType: "click" },
                                          expression: "{triggerType: 'click'}",
                                        },
                                      ],
                                      staticClass: "aclss",
                                      attrs: {
                                        href: `${_vm.localhost}/company/detail/${scope.row.buyerId}/0?wlf=ai_gpt`,
                                        target: "_blank",
                                      },
                                    },
                                    [_vm._v(_vm._s(scope.row.buyerName))]
                                  ),
                                ]),
                              ]
                            },
                          },
                          {
                            key: "productDesc",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-tooltip",
                                  {
                                    staticClass: "row-nowrap",
                                    attrs: {
                                      effect: "dark",
                                      placement: "top-start",
                                      "popper-class": "trade_tooltip",
                                      disabled: _vm.is_overflow(
                                        `productDesc_${scope.$index}`
                                      ),
                                    },
                                  },
                                  [
                                    _c("div", {
                                      attrs: { slot: "content" },
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.formatHtml(scope.row.productDesc)
                                        ),
                                      },
                                      slot: "content",
                                    }),
                                    _c("span", {
                                      attrs: {
                                        id: "productDesc_" + scope.$index,
                                      },
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.formatHtml(scope.row.productDesc)
                                        ),
                                      },
                                    }),
                                  ]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        326265526
                      ),
                    })
                  : _vm._e(),
              ],
          [1, 2].includes(_vm.datalist.dataType)
            ? _c(
                "el-dropdown",
                {
                  staticClass: "checkMore",
                  attrs: {
                    "split-button": "",
                    type: "primary",
                    trigger: "click",
                  },
                  on: { command: _vm.checkMore, click: _vm.checkList },
                },
                [
                  _vm._v(" " + _vm._s(_vm.$i18.language("查看企业列表")) + " "),
                  _c(
                    "el-dropdown-menu",
                    {
                      staticClass: "dropdown-menu",
                      attrs: { slot: "dropdown", "append-to-body": false },
                      slot: "dropdown",
                    },
                    [
                      _c("el-dropdown-item", [
                        _vm._v(_vm._s(_vm.$i18.language("查看类似企业"))),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.datalist.dataType == 3
            ? _c(
                "el-button",
                { attrs: { plain: "" }, on: { click: _vm.checkMore } },
                [_vm._v(_vm._s(_vm.$i18.language("查看更多")))]
              )
            : _vm._e(),
          _vm.datalist.dataType == 1
            ? _c(
                "el-button",
                {
                  attrs: { plain: "" },
                  on: { click: _vm.newSmartBusinessList },
                },
                [_vm._v(_vm._s(_vm.$i18.language("创建商机列表")))]
              )
            : _vm._e(),
          _vm.datalist.dataType == 5
            ? _c(
                "el-button",
                { attrs: { plain: "" }, on: { click: _vm.gotoTrade } },
                [_vm._v(_vm._s(_vm.$i18.language("查看详情")))]
              )
            : _vm._e(),
        ],
        2
      ),
      _vm.smartBusisnessVisible
        ? _c("smartBusisnessDialog", {
            ref: "smartBusisnessDialog",
            on: { closeBusisness: _vm.closeBusisness },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }